import { Injectable } from '@angular/core';

@Injectable()
export class ConversationImportCommunicationService {
  isFilesSelected: boolean;
  isFilesValid: boolean;
  isCallImport: boolean = true;
}
